"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activeCustomersApi = activeCustomersApi;
exports.listApi = listApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 查询员工积分明细列表
 */
function listApi(params) {
  return (0, _request.default)({
    url: "/admin/customers/emp/integral/list",
    method: 'GET',
    params: params
  });
}

/**
 * 获取客户
 */
function activeCustomersApi() {
  // return request({
  //   url: `/admin/customers/active-customers`,
  //   method: 'GET',
  // });

  return requestMapi({
    url: "/mapi/user/customer/active-customers",
    method: 'GET'
  });
}